import template from './has-gas.jade';

export default angular
    .module('cian.addForm.hasGas', [])
    .directive('cianAfAboutObjectHasGas', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.items = [{
                text: 'Есть',
                value: true,
            }, {
                text: 'Нет',
                value: false,
            }];
        },
        controllerAs: 'hasGas',
        template,
    }))
    .name;
